import React, { ComponentProps, FC } from 'react';

import { useTogglePlayWithIndicator } from '../../feature-player/hooks/skin/use-toggle-play-with-indicator';
import { PlayToggle } from '../../feature-player/ui/skin/play-toggle/component';

export const VodPlayToggle: FC<Omit<ComponentProps<typeof PlayToggle>, 'onClick'>> = (props) => {
    const { togglePlay } = useTogglePlayWithIndicator();

    return <PlayToggle onClick={togglePlay} {...props} />;
};
